import React, { ReactElement } from 'react';

export default function PlusSign(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='currentColor' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.5 11.9993C4.5 11.7231 4.72386 11.4993 5 11.4993H19C19.2761 11.4993 19.5 11.7231 19.5 11.9993C19.5 12.2754 19.2761 12.4993 19 12.4993H5C4.72386 12.4993 4.5 12.2754 4.5 11.9993Z' />
            <path d='M11.5 5C11.5 4.72386 11.7239 4.5 12 4.5C12.2761 4.5 12.5 4.72386 12.5 5V19C12.5 19.2761 12.2761 19.5 12 19.5C11.7239 19.5 11.5 19.2761 11.5 19V5Z' />
        </svg>
    );
}

